<template>
  <div class="breadDiv" id="domBread">
    <span style="font-size: 14px;display:inline-block;">当前位置：</span>
    <el-breadcrumb separator="/" style="display: inline-block;line-height: 10px">
      <el-breadcrumb-item
        v-for="(item, index) in breadList"
        :to="item.path"
        :key="index"
      >{{ item.meta.title }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadList: []
    };
  },
  watch: {
    $route: {
      handler(route) {
        let allList = route.matched.filter(item => {
          if (item.meta && item.meta.title) {
            if (item.redirect) {
              item.path = "";
            }
            return true;
          }
        });
        if (allList[0].path !== "/" && allList[0].path !== "/dashbord") {
          allList.unshift({ path: "/", meta: { title: "首页" } });
        }
        this.breadList = allList;
        console.log(this.breadList);
      },
      immediate: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/BreadCrumd/index.vue